import blog1 from "../../assets/images/meeting-with-client-for-gathering-requirements.webp";
import blog2 from "../../assets/images/brainstorming-the-best-software-solutions.webp";
import blog3 from "../../assets/images/website-designers-discussing-low-fidelity-mockups.webp";
import blog4 from "../../assets/images/coding-on-a-computer.webp";
import blog5 from "../../assets/images/software-testing.webp"; 


export const process = [
  {
    title: "Discovery & Requirements Gathering",
    image: blog1,
    description:
      "We listen first and listen well, making sure you’re heard and understood before being presented with a solution for your vision and goals. ",
  },
  {
    title: "Ideation  & Planning",
    image: blog2,
    description:
      "Our experts brainstorm the smartest technical solution to your requirements and present the actionable software architecture and workflows.",
  },
  {
    title: "Design & prototyping",
    image: blog3,
    description:
      "Aesthetically pleasing mockups for the software’s user-interface are presented which are further elaborated by interactive prototyping to demonstrate the software’s functionality and user-experience. ",
  },
  {
    title: "Development & testing",
    image: blog4,
    description:
      "Our in-house team of specialists executes the full-stack coding of software, while ensuring top-notch quality assurance protocols at each stage.  ",
  },
  {
    title: "Deployement & Maintenance",
    image: blog5,
    description:
      "From hassle-free launch to consistent support and upgrades, we’ve got you covered.  ",
  },
];
export const faqData = [  
  {
    id: "01",
    question:
      "What are the essentials included in a CMS website development package?",
    answer:
      "All packages include mobile-friendly designs, content editors, a training session and post-deployment support.",
  },
  {
    id: "02",
    question: "  Are our CMS websites SEO-friendly and compatible?",
    answer:
      "Yes! With the right approach and professional development practices we follow, CMS websites are SEO-friendly and perform well on search engines.  ",
  },
  {
    id: "03",
    question: " How much does a basic CMS website cost?",
    answer:
      "Our CMS web development starts at $350. The exact pricing will vary based on your requirements.",
  },
  {
    id: "04",
    question: " What if I need updates or help later?",
    answer:
      "We offer optional maintenance plans covering support and on-going updates. ",
  },
  {
    id: "05",
    question: " How do we assist with picking the right CMS platform?",
    answer:"We evaluate your requirements and then recommend the most fitting solution based on our extensive experience.",
  },
  {
    id: "06",
    question: "How soon can we deploy your completed website?",
    answer:"We can deploy a basic website within a week if required. The timelines are based entirely on the complexity, number of revisions requested and timely feedback. A timeline of 2 weeks is recommend to allow space for creative fulfillment and incorporating complex features if required. ",
  },
  {
    id: "07",
    question: " What payment options can I add to my site?",
    answer:"You can integrate popular payment options like Stripe, PayPal, and Square, along with many other secure payment gateways to instantly accept payments for your products or services.",
  },
];

 